/**
 * @file 文档搜索路由
 * @author FengGuang(fengguang01@baidu.com)
 */
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import React from 'react';

import Searchdoc from './SearchAll';

const SearchAllRouter = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/searchall" component={Searchdoc} />
            </Switch>
        </BrowserRouter>
    );
};

export default SearchAllRouter;
